import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from './new/dropdown';
import Button from './new/button';
import { CaretDownIcon } from '@phosphor-icons/react';
import { fontList } from './fontList';
import useFonts from '@lib/hooks/useFonts';

const fonts = fontList;

export type SAFonts = typeof fonts[number];

interface FontPickerProps {
  selectedFont: SAFonts;
  onSelectFont: (font: SAFonts) => void;
}
export default function FontPicker({
  selectedFont,
  onSelectFont
}: FontPickerProps) {
  const { getFontStyle } = useFonts();

  return (
    <Dropdown
      className='w-[140px] bg-white'
      placement='bottom-start'
    >
      <DropdownTrigger>
        <Button
          kind='tertiary'
          size='sm'
          className='w-[140px]'
          endContent={<CaretDownIcon size={16} />}
        >
          <p className='w-full text-start font-normal'
            style={{
              ...getFontStyle(selectedFont),
              fontSize: '90%'
            }}>{selectedFont}</p>
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label='font-picker'
        onAction={(font: string | number) => onSelectFont(font as SAFonts)}
        className='max-h-[40vh] overflow-y-auto'
        disallowEmptySelection
        selectedKeys={[selectedFont]}
        selectionMode="single"
        variant="flat"
      >
        {fonts.map(font => <DropdownItem key={font}
          style={{
            ...getFontStyle(font)
          }}
        >{font}</DropdownItem>)}
      </DropdownMenu>
    </Dropdown>
  );
}
